import styled from '@emotion/native';
import { BodyText } from '@/shared/components/StyledText';
import { lightGreen, green } from '@/shared/styles/colors';

export const LinkText = styled(BodyText)({
  color: lightGreen,
  fontSize: 12,
  textAlign: 'center',
  flexWrap: 'wrap',
  lineHeight: 16.2,
});

export const Link = styled(BodyText)({
  textDecorationLine: 'underline',
  fontWeight: 'bold',
  color: green,
  fontSize: 12,
  lineHeight: 16.2,
});

export const SectionTitle = styled(BodyText)({
  fontSize: 14,
  color: green,
});
